// extracted by mini-css-extract-plugin
module.exports = {"Title":"styles_Title__1DJDU","Title--center":"styles_Title--center__GSTkv","Title--uppercase":"styles_Title--uppercase__EFGgS"};